import { createFileRoute } from '@tanstack/react-router'
import { PageHeader } from '@/shared/components/layout/PageHeader'
import {
  ActiveIncidentsCard,
  AlertsCard,
  CoverageGapsCard,
  CoverageRequestsCard,
  LiveDeploymentCard,
  RecentActivityCard,
  TodaysShiftsCard,
} from '@/features/dashboard'
import { usePermissions } from '@/entities/session/hooks/usePermissions'
import { PERMISSIONS } from '@/shared/config/permissions'

function Dashboard() {
  const { hasPermission } = usePermissions()
  const canViewCoverageRequests = hasPermission(PERMISSIONS.CoverageRequestsView)
  const canReviewIncidents = hasPermission(PERMISSIONS.IncidentsReview)

  return (
    <>
      <PageHeader
        title="Operations overview"
        description="Live snapshot across all sites · auto-refreshing"
        breadcrumbs={[{ label: 'Dashboard' }]}
      />
      <div className="flex h-full flex-col gap-3">
        <div className="grid gap-3 lg:[grid-template-columns:1.55fr_1fr]">
          <div className="h-[460px]">
            <LiveDeploymentCard />
          </div>
          <div className="h-[460px]">
            <ActiveIncidentsCard />
          </div>
        </div>
        <div className="flex flex-col gap-3 lg:flex-row">
          <div className="h-[360px] min-w-0 flex-1">
            <TodaysShiftsCard />
          </div>
          {canReviewIncidents && (
            <div className="h-[360px] min-w-0 flex-1">
              <AlertsCard />
            </div>
          )}
        </div>
        <div className="flex flex-col gap-3 lg:flex-row">
          <div className="h-[360px] min-w-0 flex-1">
            <CoverageGapsCard />
          </div>
          {canViewCoverageRequests && (
            <div className="h-[360px] min-w-0 flex-1">
              <CoverageRequestsCard />
            </div>
          )}
        </div>
        {hasPermission(PERMISSIONS.AuditView) && (
          <div className="h-[340px]">
            <RecentActivityCard />
          </div>
        )}
      </div>
    </>
  )
}

export const Route = createFileRoute('/')({
  component: Dashboard,
  staticData: { authorize: true },
})
